import { readCookie } from "./tracking";

export type CampaignSource = "tiktok" | "meta" | "nenhum";
const ORDER_CAMPAIGN_SOURCE_COOKIE = "order_campaign_source";

/** Return the paid-media origin associated with the current visitor. */
export function getCampaignSource(href?: string): CampaignSource {
  try {
    const url = new URL(
      href || (typeof window !== "undefined" ? window.location.href : ""),
    );
    const hasMetaClick = Boolean(url.searchParams.get("fbclid"));
    const hasTikTokClick = Boolean(url.searchParams.get("ttclid"));
    if (hasMetaClick || hasTikTokClick) {
      if (hasMetaClick === hasTikTokClick) return "nenhum";
      if (hasMetaClick) return "meta";
      return "tiktok";
    }

    const source = (url.searchParams.get("utm_source") || "")
      .toLowerCase()
      .replace(/\s/g, "");
    if (["tiktok", "tik-tok", "bytedance"].some((item) => source.includes(item))) {
      return "tiktok";
    }
    if (["facebook", "instagram", "meta", "fbads", "igads"].some((item) => source.includes(item))) {
      return "meta";
    }
    if (url.searchParams.has("utm_source")) return "nenhum";

    const persistedSource = readCookie(ORDER_CAMPAIGN_SOURCE_COOKIE);
    if (persistedSource === "meta" || persistedSource === "tiktok") {
      return persistedSource;
    }
  } catch {}
  return "nenhum";
}
